"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLACAS_RANGE = [{
  start: 'AAA0001',
  end: 'BEZ9999',
  state: '',
  desc: 'Paraná]] (PR)',
  since: '02/1990'
}, {
  start: 'BFA0001',
  end: 'GKI9999',
  state: '',
  desc: 'São Paulo (estado)|São Paulo]] (SP)',
  since: '10/1991'
}, {
  start: 'GKJ0001',
  end: 'HOK9999',
  state: '',
  desc: 'Minas Gerais]] (MG)',
  since: '09/1991'
}, {
  start: 'HOL0001',
  end: 'HQE9999',
  state: '',
  desc: 'Maranhão]] (MA)',
  since: '01/1992'
}, {
  start: 'HQF0001',
  end: 'HTW9999',
  state: '',
  desc: 'Mato Grosso do Sul]] (MS)',
  since: '03/1992'
}, {
  start: 'HTX0001',
  end: 'HZA9999',
  state: '',
  desc: 'Ceará]] (CE)',
  since: '10/1992'
}, {
  start: 'HZB0001',
  end: 'IAP9999',
  state: '',
  desc: 'Sergipe]] (SE)',
  since: '09/1993'
}, {
  start: 'IAQ0001',
  end: 'JDO9999',
  state: '',
  desc: 'Rio Grande do Sul]] (RS)',
  since: '03/1992'
}, {
  start: 'JDP0001',
  end: 'JKR9999',
  state: '',
  desc: 'Distrito Federal (Brasil)|Distrito Federal]] (DF)',
  since: '04/1994'
}, {
  start: 'JKS0001',
  end: 'JSZ9999',
  state: '',
  desc: 'Bahia]] (BA)',
  since: '08/1993'
}, {
  start: 'JTA0001',
  end: 'JWE9999',
  state: '',
  desc: 'Pará]] (PA)',
  since: '07/1993'
}, {
  start: 'JWF0001',
  end: 'JXY9999',
  state: '',
  desc: 'Amazonas]] (AM)',
  since: '09/1993'
}, {
  start: 'JXZ0001',
  end: 'KAU9999',
  state: '',
  desc: 'Mato Grosso]] (MT)',
  since: '09/1993'
}, {
  start: 'KAV0001',
  end: 'KFC9999',
  state: '',
  desc: 'Goiás]] (GO)',
  since: '05/1994'
}, {
  start: 'KFD0001',
  end: 'KME9999',
  state: '',
  desc: 'Pernambuco]] (PE) ',
  since: '08/1994'
}, {
  start: 'KMF0001',
  end: 'LVE9999',
  state: '',
  desc: 'Rio de Janeiro (estado)|Rio de Janeiro]] (RJ)',
  since: '05/1994'
}, {
  start: 'LVF0001',
  end: 'LWQ9999',
  state: '',
  desc: 'Piauí]] (PI)',
  since: '04/1996'
}, {
  start: 'LWR0001',
  end: 'MMM9999',
  state: '',
  desc: 'Santa Catarina]] (SC)',
  since: '06/1996'
}, {
  start: 'MMN0001',
  end: 'MOW9999',
  state: '',
  desc: 'Paraíba]] (PB)',
  since: '07/1996'
}, {
  start: 'MOX0001',
  end: 'MTZ9999',
  state: '',
  desc: 'Espírito Santo (estado)|Espírito Santo]] (ES)',
  since: '12/1995'
}, {
  start: 'MUA0001',
  end: 'MVK9999',
  state: '',
  desc: 'Alagoas]] (AL)',
  since: '08/1996'
}, {
  start: 'MVL0001',
  end: 'MXG9999',
  state: '',
  desc: 'Tocantins]] (TO)',
  since: '11/1996'
}, {
  start: 'MXH0001',
  end: 'MZM9999',
  state: '',
  desc: 'Rio Grande do Norte]] (RN)',
  since: '06/1998'
}, {
  start: 'MZN0001',
  end: 'NAG9999',
  state: '',
  desc: 'Acre]] (AC)',
  since: '06/1998'
}, {
  start: 'NAH0001',
  end: 'NBA9999',
  state: '',
  desc: 'Roraima]] (RR)',
  since: '07/1998'
}, {
  start: 'NBB0001',
  end: 'NEH9999',
  state: '',
  desc: 'Rondônia]] (RO)',
  since: '07/1998'
}, {
  start: 'NEI0001',
  end: 'NFB9999',
  state: '',
  desc: 'Amapá]] (AP)',
  since: '09/1998'
}, {
  start: 'NFC0001',
  end: 'NGZ9999',
  state: '',
  desc: 'Goiás]] (GO) 2ª sequência',
  since: '08/2003'
}, {
  start: 'NHA0001',
  end: 'NHT9999',
  state: '',
  desc: 'Maranhão]] (MA) 2ª sequência',
  since: '12/2006'
}, {
  start: 'NHU0001',
  end: 'NIX9999',
  state: '',
  desc: 'Piauí]] (PI) 2ª sequência',
  since: '05/2007'
}, {
  start: 'NIY0001',
  end: 'NJW9999',
  state: '',
  desc: 'Mato Grosso]] (MT) 2ª sequência',
  since: '10/2007'
}, {
  start: 'NJX0001',
  end: 'NLU9999',
  state: '',
  desc: 'Goiás]] (GO) 3ª sequência',
  since: '11/2007'
}, {
  start: 'NLV0001',
  end: 'NMO9999',
  state: '',
  desc: 'Alagoas]] (AL) 2ª sequência',
  since: '01/2008'
}, {
  start: 'NMP0001',
  end: 'NNI9999',
  state: '',
  desc: 'Maranhão]] (MA) 3ª sequência',
  since: '05/2008'
}, {
  start: 'NNJ0001',
  end: 'NOH9999',
  state: '',
  desc: 'Rio Grande do Norte]] (RN) 2ª sequência',
  since: '07/2008'
}, {
  start: 'NOI0001',
  end: 'NPB9999',
  state: '',
  desc: 'Amazonas]] (AM) 2ª sequência',
  since: '07/2008'
}, {
  start: 'NPC0001',
  end: 'NPQ9999',
  state: '',
  desc: 'Mato Grosso]] (MT) 3ª sequência',
  since: '09/2008'
}, {
  start: 'NPR0001',
  end: 'NQK9999',
  state: '',
  desc: 'Paraíba]] (PB) 2ª sequência',
  since: '11/2008'
}, {
  start: 'NQL0001',
  end: 'NRE9999',
  state: '',
  desc: 'Ceará]] (CE) 2ª sequência',
  since: '12/2008'
}, {
  start: 'NRF0001',
  end: 'NSD9999',
  state: '',
  desc: 'Mato Grosso do Sul]] (MS) 2ª sequência',
  since: '11/2009'
}, {
  start: 'NSE0001',
  end: 'NTC9999',
  state: '',
  desc: 'Pará]] (PA) 2ª sequência',
  since: '11/2009'
}, {
  start: 'NTD0001',
  end: 'NTW9999',
  state: '',
  desc: 'Bahia]] (BA) 2ª sequência',
  since: '02/2010'
}, {
  start: 'NTX0001',
  end: 'NUG9999',
  state: '',
  desc: 'Mato Grosso]] (MT) 4ª sequência',
  since: '03/2010'
}, {
  start: 'NUH0001',
  end: 'NUL9999',
  state: '',
  desc: 'Roraima]] (RR) 2ª sequência',
  since: '06/2010'
}, {
  start: 'NUM0001',
  end: 'NVF9999',
  state: '',
  desc: 'Ceará]] (CE) 3ª sequência',
  since: '06/2010'
}, {
  start: 'NVG0001',
  end: 'NVN9999',
  state: '',
  desc: 'Sergipe]] (SE) 2ª sequência',
  since: '03/2010'
}, {
  start: 'NVO0001',
  end: 'NWR9999',
  state: '',
  desc: 'Goiás]] (GO) 4ª sequência',
  since: '03/2010'
}, {
  start: 'NWS0001',
  end: 'NXQ9999',
  state: '',
  desc: 'Maranhão]] (MA) 4ª sequência',
  since: '07/2010'
}, {
  start: 'NXR0001',
  end: 'NXT9999',
  state: '',
  desc: 'Acre]] (AC) 2ª sequência',
  since: '05/2011'
}, {
  start: 'NXU0001',
  end: 'NXW9999',
  state: '',
  desc: 'Pernambuco]] (PE) 2ª sequência',
  since: '07/2010'
}, {
  start: 'NXX0001',
  end: 'NYG9999',
  state: '',
  desc: 'Minas Gerais]] (MG) 2ª sequência',
  since: '10/2011'
}, {
  start: 'NYH0001',
  end: 'NZZ9999',
  state: '',
  desc: 'Bahia]] (BA) 3ª sequência',
  since: '10/2010'
}, {
  start: 'OAA0001',
  end: 'OAO9999',
  state: '',
  desc: 'Amazonas]] (AM) 3ª sequência',
  since: '12/2010'
}, {
  start: 'OAP0001',
  end: 'OBS9999',
  state: '',
  desc: 'Mato Grosso]] (MT) 5ª sequência',
  since: '05/2011'
}, {
  start: 'OBT0001',
  end: 'OCA9999',
  state: '',
  desc: 'Pará]] (PA) 3ª sequência',
  since: '07/2011'
}, {
  start: 'OCB0001',
  end: 'OCU9999',
  state: '',
  desc: 'Ceará]] (CE) 4ª sequência',
  since: '02/2011'
}, {
  start: 'OCV0001',
  end: 'ODT9999',
  state: '',
  desc: 'spírito Santo (estado)|Espírito Santo]] (ES) 2ª sequênci',
  since: '05/2011'
}, {
  start: 'ODU0001',
  end: 'OEI9999',
  state: '',
  desc: 'Piauí]] (PI) 3ª sequência',
  since: '09/2011'
}, {
  start: 'OEJ0001',
  end: 'OES9999',
  state: '',
  desc: 'Sergipe]] (SE) 3ª sequência',
  since: '08/2011'
}, {
  start: 'OET0001',
  end: 'OFH9999',
  state: '',
  desc: 'Paraíba]] (PB) 3ª sequência',
  since: '04/2011'
}, {
  start: 'OFI0001',
  end: 'OFW9999',
  state: '',
  desc: 'Pará]] (PA) 4ª sequência',
  since: '03/2011'
}, {
  start: 'OFX0001',
  end: 'OGG9999',
  state: '',
  desc: 'Paraíba]] (PB) 4ª sequência',
  since: '06/2011'
}, {
  start: 'OGH0001',
  end: 'OHA9999',
  state: '',
  desc: 'Goiás]] (GO) 5ª sequência',
  since: '04/2011'
}, {
  start: 'OHB0001',
  end: 'OHK9999',
  state: '',
  desc: 'Alagoas]] (AL) 3ª sequência',
  since: '09/2011'
}, {
  start: 'OHL0001',
  end: 'OHW9999',
  state: '',
  desc: 'Rondônia]] (RO) 2ª sequência',
  since: '11/2011'
}, {
  start: 'OHX0001',
  end: 'OIQ9999',
  state: '',
  desc: 'Ceará]] (CE) 5ª sequência',
  since: '12/2011'
}, {
  start: 'OIR0001',
  end: 'OJQ9999',
  state: '',
  desc: 'Maranhão]] (MA) 5ª sequência',
  since: '01/2012'
}, {
  start: 'OJR0001',
  end: 'OKC9999',
  state: '',
  desc: 'Rio Grande do Norte]] (RN) 3ª sequência',
  since: '04/2012'
}, {
  start: 'OKD0001',
  end: 'OKH9999',
  state: '',
  desc: 'Santa Catarina]] (SC) 2ª sequência',
  since: '02/2014'
}, {
  start: 'OKI0001',
  end: 'OLG9999',
  state: '',
  desc: 'Bahia]] (BA) 4ª sequência',
  since: '10/2011'
}, {
  start: 'OLH0001',
  end: 'OLN9999',
  state: '',
  desc: 'Tocantins]] (TO) 2ª sequência',
  since: '02/2012'
}, {
  start: 'OLO0001',
  end: 'OMH9999',
  state: '',
  desc: 'Minas Gerais]] (MG) 3ª sequência',
  since: '03/2012'
}, {
  start: 'OMI0001',
  end: 'OOF9999',
  state: '',
  desc: 'Goiás]] (GO) 6ª sequência',
  since: '04/2012'
}, {
  start: 'OOG0001',
  end: 'OOU9999',
  state: '',
  desc: 'Mato Grosso do Sul]] (MS) 3ª sequência',
  since: '02/2012'
}, {
  start: 'OOV0001',
  end: 'ORC9999',
  state: '',
  desc: 'Minas Gerais]] (MG) 4ª sequência',
  since: '06/2012'
}, {
  start: 'ORD0001',
  end: 'ORM9999',
  state: '',
  desc: 'Alagoas]] (AL) 4ªsequência',
  since: '01/2012'
}, {
  start: 'ORN0001',
  end: 'OSV9999',
  state: '',
  desc: 'Ceará]] (CE) 6ª sequência',
  since: '07/2012'
}, {
  start: 'OSW0001',
  end: 'OTZ9999',
  state: '',
  desc: 'Pará]] (PA) 5ª sequência',
  since: '08/2012'
}, {
  start: 'OUA0001',
  end: 'OUE9999',
  state: '',
  desc: 'Piauí]] (PI) 4ª sequência',
  since: '11/2012'
}, {
  start: 'OUF0001',
  end: 'OVD9999',
  state: '',
  desc: 'Bahia]] (BA) 5ª sequência',
  since: '12/2012'
}, {
  start: 'OVE0001',
  end: 'OVF9999',
  state: '',
  desc: 'spírito Santo (estado)|Espírito Santo]] (ES) 3ª sequênci',
  since: '12/2012'
}, {
  start: 'OVG0001',
  end: 'OVG9999',
  state: '',
  desc: 'Acre]] (AC) 3ª sequência',
  since: '05/2013'
}, {
  start: 'OVH0001',
  end: 'OVL9999',
  state: '',
  desc: 'spírito Santo (estado)|Espírito Santo]] (ES) 4ª sequênci',
  since: '07/2013'
}, {
  start: 'OVM0001',
  end: 'OVV9999',
  state: '',
  desc: 'Distrito Federal]] (DF) 2ª sequência',
  since: '11/2013'
}, {
  start: 'OVW0001',
  end: 'OVY9999',
  state: '',
  desc: 'Piauí]] (PI) 5ª sequência',
  since: '10/2013'
}, {
  start: 'OVZ0001',
  end: 'OWG9999',
  state: '',
  desc: 'Rio Grande do Norte]] (RN) 4ª sequência',
  since: '06/2013'
}, {
  start: 'OWH0001',
  end: 'OXK9999',
  state: '',
  desc: 'Minas Gerais]] (MG) 5ª sequência',
  since: '10/2013'
}, {
  start: 'OXL0001',
  end: 'OXL9999',
  state: '',
  desc: 'Rondônia]] (RO) 3ª sequência',
  since: '11/2013'
}, {
  start: 'OXM0001',
  end: 'OXM9999',
  state: '',
  desc: 'Amazonas]] (AM) 4ª sequência',
  since: '11/2013'
}, {
  start: 'OXN0001',
  end: 'OXN9999',
  state: '',
  desc: 'Alagoas]] (AL) 5ª sequência',
  since: '11/2013'
}, {
  start: 'OXO0001',
  end: 'OXO9999',
  state: '',
  desc: 'Paraíba]] (PB) 5ª sequência',
  since: '11/2013'
}, {
  start: 'OXP0001',
  end: 'OXP9999',
  state: '',
  desc: 'Acre]] (AC) 4ª sequência',
  since: '12/2013'
}, {
  start: 'OXQ0001',
  end: 'OXZ9999',
  state: '',
  desc: 'Maranhão]] (MA) 6ª sequência',
  since: '04/2014'
}, {
  start: 'OYA0001',
  end: 'OYC9999',
  state: '',
  desc: 'Tocantins]] (TO) 3ª sequência',
  since: '11/2013'
}, {
  start: 'OYD0001',
  end: 'OYK9999',
  state: '',
  desc: 'spírito Santo (estado)|Espírito Santo]] (ES) 5ª sequênci',
  since: '12/2013'
}, {
  start: 'OYL0001',
  end: 'OYZ9999',
  state: '',
  desc: 'Pernambuco]] (PE) 6ª sequência',
  since: '02/2014'
}, {
  start: 'OZA0001',
  end: 'OZA9999',
  state: '',
  desc: 'Ceará]] (CE) 7ª sequência',
  since: '01/2014'
}, {
  start: 'OZB0001',
  end: 'OZB9999',
  state: '',
  desc: 'Sergipe]] (SE) 4ª sequência',
  since: '01/2014'
}, {
  start: 'OZC0001',
  end: 'OZV9999',
  state: '',
  desc: 'Bahia]] (BA) 6ª sequência',
  since: '03/2014'
}, {
  start: 'OZW0001',
  end: 'PBZ9999',
  state: '',
  desc: 'Distrito Federal]] (DF) 3ª sequência',
  since: '05/2014'
}, {
  start: 'PCA0001',
  end: 'PED9999',
  state: '',
  desc: 'Pernambuco]] (PE) 7ª sequência',
  since: '12/2014'
}, {
  start: 'PEE0001',
  end: 'PFQ9999',
  state: '',
  desc: 'Pernambuco]] (PE) 3ª sequência',
  since: '09/2010'
}, {
  start: 'PFR0001',
  end: 'PGK9999',
  state: '',
  desc: 'Pernambuco]] (PE) 4ª sequência',
  since: '07/2012'
}, {
  start: 'PGL0001',
  end: 'PGU9999',
  state: '',
  desc: 'Pernambuco]] (PE) 5ª sequência',
  since: '10/2013'
}, {
  start: 'PGV0001',
  end: 'PGZ9999',
  state: '',
  desc: 'Pernambuco]] (PE) 8ª sequência',
  since: '12/2014'
}, {
  start: 'PHA0001',
  end: 'PHZ9999',
  state: '',
  desc: 'Amazonas]] (AM) 5ª sequência',
  since: '06/2014'
}, {
  start: 'PIA0001',
  end: 'PIZ9999',
  state: '',
  desc: 'Piauí]] (PI) 6ª sequência',
  since: '06/2014'
}, {
  start: 'PJA0001',
  end: 'PLZ9999',
  state: '',
  desc: 'Bahia]] (BA) 7ª sequência',
  since: '10/2014'
}, {
  start: 'PMA0001',
  end: 'POZ9999',
  state: '',
  desc: 'Ceará]] (CE) 8ª sequência',
  since: '06/2014'
}, {
  start: 'PPA0001',
  end: 'PPZ9999',
  state: '',
  desc: 'spírito Santo (estado)|Espírito Santo]] (ES) 6ª sequênci',
  since: '08/2014'
}, {
  start: 'PQA0001',
  end: 'PRZ9999',
  state: '',
  desc: 'Goiás]] (GO) 7ª sequência',
  since: '03/2015'
}, {
  start: 'PSA0001',
  end: 'PTZ9999',
  state: '',
  desc: 'Maranhão]] (MA) 7ª sequência',
  since: '12/2014'
}, {
  start: 'PUA0001',
  end: 'PZZ9999',
  state: '',
  desc: 'Minas Gerais]] (MG) 6ª sequência',
  since: '05/2014'
}, {
  start: 'QAA0001',
  end: 'QAZ9999',
  state: '',
  desc: 'Mato Grosso do Sul]] (MS) 4ª sequência',
  since: '12/2014'
}, {
  start: 'QBA0001',
  end: 'QCZ9999',
  state: '',
  desc: 'Mato Grosso]] (MT) 6ª sequência',
  since: '05/2014'
}, {
  start: 'QDA0001',
  end: 'QEZ9999',
  state: '',
  desc: 'Pará]] (PA) 6ª sequência',
  since: '10/2014'
}, {
  start: 'QFA0001',
  end: 'QFZ9999',
  state: '',
  desc: 'Paraíba]] (PB) 6ª sequência',
  since: '05/2014'
}, {
  start: 'QGA0001',
  end: 'QGZ9999',
  state: '',
  desc: 'Rio Grande do Norte]] (RN) 5ª sequência',
  since: '09/2014'
}, {
  start: 'QHA0001',
  end: 'QJZ9999',
  state: '',
  desc: 'Santa Catarina]] (SC) 3ª sequência',
  since: '05/2014'
}, {
  start: 'QKA0001',
  end: 'QKM9999',
  state: '',
  desc: 'Tocantins]] (TO) 4ª sequência',
  since: '11/2014'
}, {
  start: 'QKN0001',
  end: 'QKZ9999',
  state: '',
  desc: 'Sergipe]] (SE) 5ª sequência',
  since: '06/2014'
}, {
  start: 'QLA0001',
  end: 'QLM9999',
  state: '',
  desc: 'Alagoas]] (AL) 6ª sequência',
  since: '09/2015'
}, {
  start: 'QLN0001',
  end: 'QLT9999',
  state: '',
  desc: 'Amapá]] (AP) 2ª sequência',
  since: '01/2015'
}, {
  start: 'QLU0001',
  end: 'QLZ9999',
  state: '',
  desc: 'Acre]] (AC) 5ª sequência',
  since: '08/2014'
}, {
  start: 'QMA0001',
  end: 'QMP9999',
  state: '',
  desc: 'Sergipe]] (SE) 6ª sequência',
  since: '03/2017'
}, {
  start: 'QMQ0001',
  end: 'QQZ9999',
  state: '',
  desc: 'Minas Gerais]] (MG) 7ª sequência ',
  since: '07/2017'
}, {
  start: 'QRA0001',
  end: 'QRA9999',
  state: '',
  desc: 'Rondônia]] (RO) 4ª sequência',
  since: '11/2017'
}, {
  start: 'QRB0001',
  end: 'QRZ9999',
  state: '',
  desc: 'Espírito Santo (estado)|Espírito Santo]] (ES) 7ª sequência',
  since: '05/2018'
}, {
  start: 'QSA0001',
  end: 'QSZ9999',
  state: '',
  desc: 'Paraíba]] (PB) 7ª sequência',
  since: '04/2018'
}, {
  start: 'QTA0001',
  end: 'QTB9999',
  state: '',
  desc: 'Rondônia]] (RO) 5ª sequência',
  since: '08/2018'
}, {
  start: 'QTC0001',
  end: 'RIN9999',
  state: '',
  desc: 'quên',
  since: 'inidas '
}, {
  start: 'RIO0001',
  end: 'RIO9999',
  state: '',
  desc: 'Rio de Janeiro (estado)|Rio de Janeiro]] (RJ) 2ª sequência ',
  since: '9/2018}'
}, {
  start: 'RLA0001',
  end: 'SAU9999',
  state: '',
  desc: 'equên',
  since: 'inidas '
}, {
  start: 'SAV0001',
  end: 'SAV9999',
  state: '',
  desc: 'ão Paulo (estado)|São Paulo]] (SP) 2º sequência',
  since: '09/2009'
}];
exports.PLACAS_INVALID = {
  start: 'SAW0001',
  end: 'ZZZ9999'
}; // || Sequências ainda não definidas

function validate_placa(placa) {
  var placaClean = placa.toString();
  placaClean = placaClean.replace(/-/g, '').toUpperCase();
  var exp = /[A-Za-z]{3}\-\d{4}/;
  var expClean = /[A-Za-z]{3}\d{4}/; // const letters = placa.substr(0, 3).toUpperCase();

  var placaString = placa.toString();

  if (!exp.test(placaString) && !expClean.test(placaClean)) {
    return false;
  }

  var found = placaString >= exports.PLACAS_INVALID.start && placaString <= exports.PLACAS_INVALID.end;

  if (found) {
    return false;
  } else {
    return true;
  }
}

exports.validate_placa = validate_placa;